export default __webpack_public_path__ + "static/media/home.4bd4ddbe.svg";